/* eslint-disable eqeqeq */
import React, {
    useState,
    useRef,
    useImperativeHandle,
    forwardRef
} from 'react';
import TextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core/styles';
import SearchRoundedIcon from '@material-ui/icons/SearchRounded';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import api from '../../../services/api';
import Swal from 'sweetalert2';
import theme from '../../layout/theme'

const tema = theme();

const useStyles = makeStyles(theme => ({
    controlaTitulo: {
        paddingTop: 30,
        paddingBottom: 12,
        fontSize: "2em",
    },
    corDoFundo: {
        backgroundColor: "#f1f1f1",
        paddingBottom: 30,
        height: '100%'
    },
    containerPrimeiroAcesso: {
        padding: '0px 0px 30px 0px'
    },
    controlaCard: {
        textAlign: "center",
        padding: theme.spacing(2),
    },
    inputButton: {
        background: tema.theme.linearGradientPrimary,
        color: '#FFF',
        marginTop: 15,
        marginBottom: 15
    },
    input: {
        display: 'none'
    }
}))



function FormCertificado(props, ref) {
    const { primeiroAcesso } = props;

    const classes = useStyles();

    const certificado = useRef(null);

    const [senhaCertificado, setSenhaCertificado] = useState('');
    const [senhaCertificadoErro] = useState(false);
    const [senhaCertificadoErroTexto] = useState('')

    const toBase64 = file => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });

    useImperativeHandle(ref, () => ({
        async salvarCertificado() {
            let retornoSalvar = await salvar();
            return retornoSalvar;
        }
    }));

    async function salvar(e) {
        if (e) {
            e.preventDefault();
        }

        if (validarCampos()) {
            let fileBase64 = await toBase64(certificado.current.files[0]);
            fileBase64 = fileBase64.replace(/^data:.+;base64,/, '');

            let dadosCertificado = {
                DBSERVERNAME: localStorage.getItem("DBSERVERNAME"),
                DBUSERNAME: localStorage.getItem("DBUSERNAME"),
                DBPID: localStorage.getItem("DBPID"),
                DBESQUEMA: localStorage.getItem("DBESQUEMA"),
                MANDNUMBER: localStorage.getItem("MANDNUMBER"),
                CCDLOGIN: localStorage.getItem("CCDLOGIN"),
                CNRSWCON: localStorage.getItem("CNRSWCON"),
                EMPNUMBER: localStorage.getItem("EMPNUMBER"),
                USERNUMBER: localStorage.getItem("USERNUMBER"),
                SESSIONNUMBER: 0,
                PARAMNAMES: "INSTAL-CERTIFICADO", //nome do servico
                PARAMVALUES: 0, //codigo da empresa sem estar criptografado
                CERTFILE: fileBase64, //certificado em base 64
                CERTNAME: certificado.current.files[0].name, //nome do certificado
                CERTSENHA: senhaCertificado //senha do certificado
            }

            const retornoCertificado = await api.post('/execute/certificado', dadosCertificado);
            if (retornoCertificado.data.erro == 0) {
                if (!primeiroAcesso) {
                    Swal.fire({
                        type: 'success',
                        title: retornoCertificado.data.msg
                    });
                }

                return true;
            } else {
                Swal.fire({
                    type: 'error',
                    title: retornoCertificado.data.msg
                })
            }
        }
    }

    function validarCampos() {

        if (certificado.current.files.length === 0) {
            Swal.fire({
                type: 'error',
                title: 'Adicione um Certificado',
            })
            return false;
        }

        if (certificado.current.files[0].type != 'application/x-pkcs12') {
            Swal.fire({
                type: 'error',
                title: 'Informe um arquivo do tipo Certificado Digital',
            })
            return false;
        }

        if (senhaCertificado === '') {
            Swal.fire({
                type: 'error',
                title: 'Informe a senha do Certificado',
            })
            return false;
        }

        return true;

    }


    return (
        <Container className={primeiroAcesso ? classes.containerPrimeiroAcesso : classes.corDoFundo}>
            {!primeiroAcesso && <Typography
                variant="h1"
                component="h1"
                gutterBottom
                align="center"
                color="primary"
                className={classes.controlaTitulo}
            >
                Certificado Empresa
            </Typography>}

            <Paper className={classes.controlaCard} variant={primeiroAcesso && "outlined"}>
                <form>
                    <Grid container>
                        <Grid item xs={12}>
                            <input
                                accept=".pfx"
                                className={classes.input}
                                id="contained-button-file"
                                ref={certificado}
                                type="file"
                            />
                            <label htmlFor="contained-button-file">
                                <Button
                                    variant="contained"
                                    className={classes.inputButton}
                                    startIcon={<SearchRoundedIcon />}
                                    component="span"
                                >
                                    Procurar Arquivo
                                </Button>
                            </label>
                        </Grid>

                        <Grid item xs={12}>
                            <Typography
                                variant="body1"
                                component="body1"
                                gutterBottom
                                align="center"
                                color="primary"
                            >
                                Após selecionar o certificado digite a senha abaixo:
                            </Typography>
                        </Grid>

                        <Grid item xs={12}>
                            <TextField
                                label="Senha do Certificado"
                                error={senhaCertificadoErro}
                                helperText={senhaCertificadoErroTexto}
                                margin="normal"
                                type="password"
                                fullWidth
                                variant="outlined"
                                value={senhaCertificado}
                                onChange={e => setSenhaCertificado(e.target.value)}

                            />
                        </Grid>

                        {!primeiroAcesso && <Grid item xs={12}>
                            <Button
                                variant="contained"
                                color="primary"
                                fullWidth
                                type="submit"
                                onClick={salvar}
                            >
                                Salvar
                            </Button>
                        </Grid>
                        }

                    </Grid>
                </form>
            </Paper>

        </Container>
    )

}

export default forwardRef(FormCertificado);